import React, { Component } from 'react';

import { Logo, Button } from '../util';

import '../App.css';

/**
 * @prop runAppHandler
 */
export default class Homepage extends React.Component {

  constructor (props) {
    super(props);


  }


  render() {
    return (
      <div>
        <Logo size="10em" />
        <Button className="diary-button" value='Start to write down your Way of Life ' onClick={this.props.runAppHandler} />
        <br /><br />
        <Button className="diary-button" value='What is this? ' onClick={this.props.writeupHandler} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/page/Homepage.js